(function ($) {
  $(function () {
    const resetSearch = $(".js-reset-search");

    if (!resetSearch.length) {
      return;
    }

    resetSearch.on('click', function(e){
        e.preventDefault();

        history.pushState(null, '', location.href.split('?')[0]);
        location.reload();
    });
  });
})(jQuery);
